import Vue from "vue";
import VueRouter from "vue-router";
import mainLayout from "@/components/mainLayout";
import index from "./modules/index";
import formwork from "./modules/formwork";
import product from "./modules/product";
import batch from "./modules/batch";
import code from "./modules/code";
import instance from "./modules/instance";
import agent from "./modules/agent";
import store from "./modules/store";
import assembly from "./modules/assembly";
import boxing from "./modules/boxing";
import warehouse from "./modules/warehouse";
import goods from "./modules/goods";
import bank from "./modules/bank";
import process from "./modules/process";
import manage from "./modules/manage";
import system from "./modules/system";
Vue.use(VueRouter);

const router = new VueRouter({
    routes:[
        {
            path:'/admin',
            meta: {title: '首页'},
            component: mainLayout,
            children: [ 
                ...index,
                formwork,
                product,
                ...batch,
                ...code,
                ...instance,
                agent,
                store,
                ...assembly,
                boxing,
                warehouse,
                goods,
                ...bank,
                ...process,
                manage,
                system
            ]
        },
        {
            name: '登录',
            path: '/',
            component: ()=>import("@/pages/login/login.vue")
        }
    ]
})

router.beforeEach((to, from, next) => {
    window.document.title = "互联溯源系统";
    next();
})
export default router;